export default __webpack_public_path__ + "static/media/logo-collapsed.42173b28.png";